<template>
  <b-alert
    show
    variant="warning"
    v-if="
      Object.keys(user).length &&
        user.acceptStatus.toLowerCase() !== 'allowed' &&
        !dismissed
    "
    style="margin-bottom: 0; border-radius: 0"
    class="d-print-none"
  >
    <p>
      <b-icon icon="exclamation-triangle" font-scale="1.3" />
      {{ paymentMessage[0] }}
      <strong v-if="user.amountDue > 0"
        >{{ (user.amountDue / 100) | currency(user.currency) }}
        {{
          $t('quote_form.total_cost_ex_vat_label')
            .charAt(0)
            .toLowerCase() + $t('quote_form.total_cost_ex_vat_label').slice(1)
        }}</strong
      >
    </p>

    <b-button
      variant="primary"
      class="mr-2"
      @click="
        $router.push({ name: 'Payment', params: { userId: user.userId } })
      "
      >{{ paymentMessage[1] }}</b-button
    >

    <b-button
      v-if="user.acceptStatus.toLowerCase() === 'previous_payment_failure'"
      variant="primary"
      class="mr-2"
      @click="dismissed = true"
      >{{ $t('buttons.keep_current_card') }}</b-button
    >

    <b-button
      v-if="user.acceptStatus.toLowerCase() === 'unsettled_debt'"
      v-b-toggle="`payment-details-${collapseID}`"
      @click="collapsed = !collapsed"
      >{{
        collapsed ? $t('buttons.details') : $t('buttons.show_less')
      }}</b-button
    >

    <b-collapse
      :id="`payment-details-${collapseID}`"
      class="mt-2"
      v-if="user.acceptStatus.toLowerCase() === 'unsettled_debt'"
    >
      <b-table-simple responsive hover dark>
        <b-thead>
          <b-tr>
            <b-th>{{ $t('user.payment_history.date') }}</b-th>
            <b-th colspan="2">{{ $t('user.payment_history.amount') }}</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(item, i) in user.pendingPayment" :key="i">
            <td>{{ item.date | date }}</td>
            <td>{{ (item.amount / 100) | currency(user.currency) }}</td>
            <td>{{ item.name }}</td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-collapse>
  </b-alert>
</template>
<script>
export default {
  data() {
    return {
      collapseID: Math.random(),
      collapsed: true,
      dismissed: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    paymentMessage() {
      let message = [];

      switch (this.user.acceptStatus.toLowerCase()) {
        case 'unsettled_debt':
          message[0] = this.$t('user.payment.unsettled_debt_message');
          message[1] = this.$t('user.payment.action_settle');
          break;
        case 'no_manual_access':
          message[0] = this.$t('user.payment.no_manual_access_message');
          message[1] = this.$t('user.payment.action_pay');
          break;
        case 'card_details_missing':
          message[0] = this.$t('user.payment.card_details_missing_message');
          message[1] = this.$t('user.payment.action_pay');
          break;
        case 'previous_payment_failure':
          message[0] = this.$t('user.payment.previous_payment_failure', {
            cc: this.user.ccPart,
          });
          message[1] = this.$t('buttons.change_card');
          break;
        default:
          break;
      }

      return message;
    },
  },
};
</script>
